"use strict";
// @ts-ignore
try {
    self['workbox:navigation-preload:6.1.5'] && _();
}
catch (e) { }
